export default __webpack_public_path__ + "static/media/47_desktop.42e0d1ef.jpg";